/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { v4ApplicationDealerportalGet } from '../fn/application/v-4-application-dealerportal-get';
import { V4ApplicationDealerportalGet$Params } from '../fn/application/v-4-application-dealerportal-get';

@Injectable({ providedIn: 'root' })
export class ApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4ApplicationDealerportalGet()` */
  static readonly V4ApplicationDealerportalGetPath = '/v4/application/dealerportal';

  /**
   * Get the dealer portal url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationDealerportalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationDealerportalGet$Response(params?: V4ApplicationDealerportalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4ApplicationDealerportalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the dealer portal url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationDealerportalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationDealerportalGet(params?: V4ApplicationDealerportalGet$Params, context?: HttpContext): Observable<void> {
    return this.v4ApplicationDealerportalGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
